// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSharedAddressModel {
    static getAttributeTypeMap() {
        return PayorSharedAddressModel.attributeTypeMap;
    }
}
PayorSharedAddressModel.discriminator = undefined;
PayorSharedAddressModel.additionalProperties = false;
PayorSharedAddressModel.attributeTypeMap = [
    {
        "name": "addressId",
        "baseName": "addressId",
        "type": "number"
    },
    {
        "name": "addressType",
        "baseName": "addressType",
        "type": "AddressType"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "addressTwo",
        "baseName": "addressTwo",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
];
//# sourceMappingURL=payorSharedAddressModel.js.map